import { defineMessages } from "react-intl";

export const messages = defineMessages({
  externalApp: {
    id: "nA2g2e",
    defaultMessage: "External app",
    description: "label",
  },
  tunnelDevelopment: {
    id: "RjT+Vo",
    defaultMessage: "Tunnel - development",
    description: "label",
  },
  nothingInstalledPlaceholder: {
    defaultMessage: "Nothing installed yet.",
    description: "placeholder",
    id: "9g6Y7a",
  },
});
